<template>
    <section class="facteure white" :class="$vuetify.rtl? 'facteure-rtl':'facteure-ltr'"  
    :style="openConfirmOrder ? {top:0}:{top:'100vh'}">
        <v-container fluid class="pa-0">
         <v-simple-table height="54vh" light  class="rounded-0" fixed-header>
         <thead class="text-center">
         <tr><th colspan="3">
         <v-btn @click="openConfirmOrder=false" depressed class="d-block d-md-none"
         style="top:3px" absolute dark color="red" small  fab>
         <v-icon>fa fa-arrow-circle-left</v-icon></v-btn>
         <h3>{{$t("orders.facteur.shpingCard")}}</h3></th></tr>
         <tr>
            <th>{{$t("orders.facteur.items")}}</th>
            <th class="pe-7">{{$t("orders.facteur.quantite")}}</th>
            <th>{{$t("orders.facteur.price")}}</th>
         </tr>
         </thead>
         <tbody>
         <tr v-for="(order,index) in this.$store.state.orders" :key="index">
          <td class="ps-1 pt-1 pb-1">
          <img  :src="order.img">
           <span class="pl-3 pr-3 font-weight-bold text-caption" v-text="order.name"></span>
          </td>
          <td>
          <div class="d-flex justify-space-between align-center ">
            <v-text-field
                       style="width:90px"
                       class="myfield"
                        v-model.number="order.quntite"
                        light
                        dense
                        height="20"
                        :readonly='true'
                        append-outer-icon="fa fa-plus-circle"
                        @click:append-outer="increment(index)"
                        prepend-icon="fa-minus-circle"
                        @click:prepend="decrement(index)"
                       ></v-text-field>
          </div>
          </td>
          <td class="pe-2 " style="position: relative">
          <div class="d-flex align-center">
          <span class="font-weight-medium"> {{order.price}}$</span> 
          <v-btn fab text color="red" light  x-small @click="removeOrder(index)"><v-icon>fa fa-trash</v-icon></v-btn>
          </div>
          </td>
         </tr>
         </tbody>
          <!---->
         </v-simple-table>
           <div class="confirm-order white pt-2 pb-3 pl-3 pr-3 mt-O rounded-0">
           <div class="pt-2 pb-3">
            <v-text-field label="add coupon code" :rules="rules" hide-details="auto" :counter="20" 
                outlined dense v-model.lazy="couponCode"
                ></v-text-field>
           </div>
           <hr>
           <div class="d-flex justify-space-between pt-2">
           <p class="text-caption font-weight-bold">{{$t("orders.facteur.total")}}</p>
           <p class="text-caption font-weight-bold">{{totalPrice}}$</p>
           </div>
          
           <div class="d-flex justify-space-around pt-2">
           <v-btn   outlined width="49%" small depressed :ripple="true"
            @click="resteOrders()"
            v-show="this.$store.state.orders.length!=0"
           >{{$t("orders.facteur.cancel")}}</v-btn>
           <v-btn color="black" small dark  width="49%" depressed :ripple="true"
           v-show="this.$store.state.orders.length!=0"
           @click="openConfirmDialog()"
           >{{$t("orders.facteur.confirm")}}</v-btn>
           </div>
         </div>
         </v-container>
         <v-fab-transition>
         <v-btn class="d-md-none" v-show="!openConfirmOrder" fixed right bottom fab @click="openConfirmOrder=true"
          color="red" large dark draggable style="bottom:16%"
         ><v-icon>fa fa-shopping-cart </v-icon></v-btn>
         </v-fab-transition>
    </section>
</template>

<script>
export default {
    name:'fact',
    data() {
        return {
            foo:1,
            openConfirmOrder:false,
            rules: [
                    
            ],
            confirmBtnLoading:false,
            annuleBtnLoading:false,
            orderExist:true,
            couponCode:''
        }
    },
    components:{
        
    },
    computed:{
     totalPrice : function(){
        let total=0;
        this.$store.state.orders.forEach(order=>total+=parseInt(order.price)*parseInt(order.quntite))
        return total;
    }
    },
    methods:{
        increment(index){
            this.$store.state.orders[index].quntite=parseInt(this.$store.state.orders[index].quntite)+1;
            if (this.$store.state.orders[index].quntite>=10) {
               this.$store.state.orders[index].quntite=10;
           }
        },
        decrement(index){
           this.$store.state.orders[index].quntite=parseInt(this.$store.state.orders[index].quntite)-1;
           if (this.$store.state.orders[index].quntite<=1) {
               this.$store.state.orders[index].quntite=1;
           }
        },
        removeOrder(index){
            this.$store.state.orders.splice(index,1);
        },
        resteOrders(){
            this.$store.state.orders=[];
        },
        openConfirmDialog(){
            this.$store.state.isconfirmOrderOpen=true
        }
    }
}
</script>

<style lang="scss" scoped>
    .facteure-ltr{
       right:  0;
    }
    .facteure-rtl{
       left:  0;
       border-right: 1px solid #000;
    }
    .facteure{
        position: fixed;
        top: 56px ;
        width: 374px ;
        height: 100vh;
        z-index: 2;
        border-left: 1px solid #000;
        border-color: #000 !important;
        transition: all .5s ease-in;
        img{
            max-width: 48px;
            max-height: 46px;
            display: inline-block;
            vertical-align: middle;
        }
        i.fa-trash{
            font-size: 14pt;
            cursor: pointer;
            &:hover{
                color: red;
            }
        }
        .confirm-order{
            position: absolute;
            width: 100%;
            bottom: 62px;
            left: 0;
        }
        }
        @media (min-width: 960px){
            .facteure{
               top: 56px !important;
               transition: none;
            }
        }
        @media (max-width: 960px) {
         h3{
             text-align: center;
         }
         .facteure{
            width: 100%;
            top: 100vh;
            z-index: 99;
        }
       }
</style>